if (!customElements.get('vf-product-gallery')) {
  customElements.define('vf-product-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const config = JSON.parse(this.querySelector('[data-gallery-config]').textContent);
      const collages = config.colorCollages?.[this.dataset.color] || (this.dataset.color === config.defaultColor ? config.collages : []);
      const editorial = collages.length > 0;
      const pair = config.modelPhotos?.[this.dataset.color];
      const men = config.kind?.startsWith('men-');
      const primaryLabel = men ? this.dataset.maleLabel : this.dataset.primaryLabel;
      const secondaryLabel = men ? (config.kind === 'men-shoes' ? this.dataset.shoeDetailLabel : this.dataset.poseLabel) : this.dataset.youngLabel;
      const pairLabel = men ? this.dataset.allViewsLabel : this.dataset.pairLabel;
      this.photos = pair ? [
        {src:pair.url,crop:pair,label:primaryLabel},
        {src:pair.url,crop:{...pair,cropX:pair.width/2},label:secondaryLabel},
        {src:pair.url,crop:null,label:pairLabel}
      ] : [{src: editorial ? collages[0].url : (config.colors?.[this.dataset.color] || this.dataset.nativeImage), crop: editorial ? collages[0] : null, label: editorial ? this.dataset.primaryLabel : this.dataset.nativeLabel}];
      if (editorial) collages.forEach((item,index) => this.photos.push({src:item.url,crop:null,label:this.dataset.moreLabel + ' ' + (index+1)}));
      const thumbnails = this.querySelector('.vf-gallery-thumbnails');
      this.photos.forEach((photo,index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'vf-gallery-thumb';
        button.setAttribute('aria-label', photo.label + ': ' + this.dataset.title + ' - ' + this.dataset.color);
        button.dataset.index = index;
        button.append(this.createPhoto(photo, true));
        thumbnails.append(button);
      });
      this.addEventListener('click',event => {
        const button=event.target.closest('.vf-gallery-thumb');
        if(button && this.contains(button)) this.select(Number(button.dataset.index));
      });
      this.select(0);
    }
    createPhoto(photo, thumbnail) {
      const img=document.createElement('img');
      img.alt=photo.label+' — '+this.dataset.title+' - '+this.dataset.color;
      img.src=photo.src;
      img.loading=thumbnail?'lazy':'eager';
      img.decoding='async';
      if(!photo.crop) {img.className='vf-gallery-full';return img;}
      const crop=photo.crop;
      const frame=document.createElement('div');
      frame.className='vf-gallery-frame';
      frame.style.setProperty('--vf-ratio',crop.cropWidth/crop.cropHeight);
      frame.style.setProperty('--vf-image-width',(crop.width/crop.cropWidth*100)+'%');
      img.width=crop.width;img.height=crop.height;
      img.style.left=(-(crop.cropX || 0)/crop.cropWidth*100)+'%';
      img.style.top=(-(crop.cropY || 0)/crop.cropHeight*100)+'%';
      frame.append(img);
      return frame;
    }
    select(index) {
      const photo=this.photos[index];
      if(!photo)return;
      this.querySelector('.vf-gallery-stage').replaceChildren(this.createPhoto(photo,false));
      this.querySelectorAll('.vf-gallery-thumb').forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
      this.querySelector('[data-gallery-status]').textContent=photo.label+' - '+this.dataset.color;
      this.querySelector('.vf-gallery-enlarge').href=photo.src;
    }
  });
}
